export default __webpack_public_path__ + "static/media/decrease-serving.4ee208c8.svg";